<ng-container *ngIf="isLoaded && notifications.length>0">
  <div *ngFor="let notification of notifications">
    <div class="notification-bloc">

      <div class="cancel-student-row">
        <div class="dashboard-maininfo">
          <span class="notif-title">{{ notification.base_notification.title }}</span>
          <span class="notif-content" [innerHtml]="notification.web_content"></span>
        </div>

        <div class="btn-row">
          <div class="dashboard-btn suboption" (click)="gotoAndDeleteNotification(notification)"
            *ngIf="notification.has_action_button">
            <span translate>teacher.dashboard-teacher.go-to</span>

            <ng-container *ngIf="notification.action_object_url">
              <span translate>teacher.dashboard-teacher.see-training</span>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="deletenotif-btn" (click)="deleteNotification(notification)" *ngIf="notification.has_deleted_button">
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isLoaded">
  <div class="white-text row center">
    <span translate>teacher.dashboard-teacher.notifications-loading</span>
  </div>
</ng-container>

<ng-container *ngIf="isLoaded && notifications.length==0">
  <div class="nonotif-message">
    <span translate>teacher.dashboard-teacher.upToDate</span>
  </div>
</ng-container>